import { Controller } from '@hotwired/stimulus'
import { apiURL } from '../utilities.js'

export default class extends Controller {
  static targets = ['currency', 'flagTemplate', 'skeleton']

  connect() {
    // this will be set to `true` after the first API call to prevent
    // unnecessary DOM manipulations
    this.currencyShown = false
  }

  async requestPrice(endpoint, credits = null) {
    // build URL and get country specific pricing if ?country param is present
    const priceURL = new URL(`${apiURL()}/site/prices/${endpoint}`)

    if (credits) priceURL.searchParams.append('quantity', credits)

    const response = await fetch(priceURL)
    return response
  }

  updateCurrency(currency) {
    // only show currency/flag for non USD currencies and do not continually
    // re-render if it is already shown
    if (currency.country === 'US' || this.currencyShown) return

    const flagTemplate = document.querySelector(
      `template[data-country=${currency.country.toLowerCase()}]`
    )

    if (flagTemplate) {
      this.currencyTarget.prepend(flagTemplate.content.cloneNode(true))
    }

    this.currencyTarget.querySelector('currency-code').textContent =
      currency.iso_code

    this.currencyTarget.hidden = false
    this.currencyShown = true
  }
}
